// 收款合同
import request from '@/plugins/axios'
//我的签约-查询
export function queryContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/pageForMy',
        method: 'post',
        data
    })
}
// 我的签约-详情
export function queryContractReceivePaymentDetailsApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/detail',
        method: 'post',
        data
    })
}
// 我的签约-新增
export function addContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/add',
        method: 'post',
        data
    })
}
// 我的签约-编辑
export function editContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/update',
        method: 'post',
        data
    })
}
// 我的签约-变更
export function changeContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/change',
        method: 'post',
        data
    })
}
// 我的签约-撤销
export function withdrawContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/withdraw',
        method: 'post',
        data
    })
}
// 我的签约-重新发起
export function reAddContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/reAdd',
        method: 'post',
        data
    })
}
// 我的签约-删除
export function deleteContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/delete',
        method: 'post',
        data
    })
}
// 我的签约-收款合同回款计划-删除
export function deleteContractReceivePaymentPlanApi(data) {
    return request({
        url: '/contractReceivePaymentPlan/v1.0.0/delete',
        method: 'post',
        data
    })
}
// 我的签约-审批进度
export function processContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/auditProcess',
        method: 'post',
        data
    })
}
// 收款合同审核-分页查询
export function queryPageForAuditApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/pageForAudit',
        method: 'post',
        data
    })
}
// 收款合同审核-审核
export function setContractReceivePaymentAuditRecordApi(data) {
    return request({
        url: '/contractReceivePaymentAuditRecord/v1.0.0/audit',
        method: 'post',
        data
    })
}

// 收款合同台账-查询
export function queryPageForLedgerApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/pageForLedger',
        method: 'post',
        data
    })
}

// 收款合同台账-查询-list
export function queryPageForLedgerListApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/listJsonAble',
        method: 'post',
        data
    })
}
// 审批过程描述
export function queryAuditProcessDescriptionApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/auditProcessDescription',
        method: 'post',
        data
    })
}
// 收款合同-续签
export function renewContractReceivePaymentApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/renew',
        method: 'post',
        data
    })
}

// 收款合同-同名合同查询（按合同名称精确匹配）
export function queryContractReceivePaymentListJsonApi(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/listJson',
        method: 'post',
        data
    })
}

// 收款合同台账-导出
export function exportForLedger(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/exportForLedger',
        method: 'post',
        responseType:'blob',
        data
    })
}

// 收款合同我的-导出
export function exportForMy(data) {
    return request({
        url: '/contractReceivePayment/v1.0.0/exportForMy',
        method: 'post',
        responseType:'blob',
        data
    })
}

// 通过项目-获取开票和收款数据
export function getProjectsInvoiceAndReceivedDataApi(data) {
    return request({
        url: '/proProjects/v1.0.0/getInvoiceAndReceivedData',
        method: 'post',
        data
    })
}